<template>
	<div id="app" >
        <component :is="layout">
			<router-view />
		</component>
	</div>
</template>

<script>

import { mapActions, mapState } from 'pinia';
import { useAuthStore } from './stores/auth-store';
import { useLocaleStore } from './stores/locale-store';
import i18n from './locales/i18n';

export default {
    computed: {

        ...mapState(useLocaleStore, [ 'locale' ]),
        // Sets components name based on current route's specified layout, defaults to
        // <layout-default></layout-default> component.
        layout() {
            return "layout-" + ( this.$route.meta.layout || "default" ).toLowerCase() ;
        }
    },
    methods: {
        ...mapActions(useAuthStore, [ 'init' ]),
        ...mapActions(useLocaleStore, { 'initLocale': 'init', 'getLocale': 'getLocale' })
    },
    mounted() {
        this.initLocale();
        this.init();
        // document.title = this.$t('landing.heading');
        
        // 
        
    },
    watch: {
        locale: {
            immediate: true,
            handler() {
                i18n.locale = this.locale;
                if (this.locale == 'bn') {
                    document.body.classList.add('bn');
                } else
                    document.body.classList.remove("bn");
                document.title = this.$t('master-page-title');
            }
            
        }
    }
}
	
</script>

<style lang="scss">
</style>